export const clientUrl = {
  name: {
    presence: {
      allowEmpty: false
    }
  },
  slug: {
    presence: {
      allowEmpty: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/validators/clientUrl.js